@if (toastService.toast(); as t) {
<div class="app-toast">
  <span class="app-toast__icon">
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
      stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
      <polyline points="20 6 9 17 4 12" />
    </svg>
  </span>

  <div class="app-toast__body">
    <span class="app-toast__message">{{ t.message }}</span>
    @if (t.detail) {
      <span class="app-toast__detail">{{ t.detail }}</span>
    }
  </div>

  @if (t.onUndo) {
    <button type="button" class="app-toast__undo" (click)="onUndo()">
      {{ t.undoLabel ?? 'Undo' }} ({{ t.secondsLeft }}s)
    </button>
  }

  <button type="button" class="app-toast__close" aria-label="Dismiss" (click)="onDismiss()">×</button>
</div>
}
